import { Page } from 'common'
import { ErrorHandler, Header } from 'components'

import { useManageNotifications } from '../hooks/useManageNotifications'
import { ManageNotificationsView } from './ManageNotificationsView'

function ManageNotifications() {
  const {
    isError,
    title,
    alertSection,
    doNotDisturbSection,
    headerSection,
    productsSection,
    descriptionSection,
    userCountry,
    traceDetails,
  } = useManageNotifications()

  const isHeaderInvalid = !title || !headerSection
  const isContentInvalid = !alertSection || !doNotDisturbSection || !productsSection

  if (isHeaderInvalid || isContentInvalid || isError)
    return <ErrorHandler traceDetails={traceDetails} componentName={ManageNotifications.name} />

  return (
    <Page>
      <Header title={title} />
      <ManageNotificationsView
        alertSection={alertSection}
        headerSection={headerSection}
        descriptionSection={descriptionSection}
        productMenu={productsSection.productMenu}
        isBrazil={userCountry === 'BR'}
        title={productsSection.title ?? ''}
      />
    </Page>
  )
}

export { ManageNotifications }
